import React, { memo, Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';

import ImageUploader from '../../../common/ImageUploader';

import { DEFAULT_EMPTY_VALUE } from '../../../../constants/strings';

import { checkIsPaperworkFlow } from '../../utils';
import { DOCUMENTATION_TYPES } from '../../../../constants';

import styles from './index.styl';

const InsuranceCardsSection = ({
  fields,
  flowType,
  isAdditionalInsurance,
  skipInsurance,
  title,
}) => {
  const isPaperworkFlowType = checkIsPaperworkFlow(flowType);

  const showEmptyDefaultValue = useMemo(() => {
    if (
      fields.some(item => item.fieldName === DOCUMENTATION_TYPES.DRIVER_LICENCE)
    ) {
      return !fields.some(item => item.src);
    }

    return isPaperworkFlowType && skipInsurance && !isAdditionalInsurance;
  }, [isPaperworkFlowType, skipInsurance, isAdditionalInsurance, fields]);

  return (
    <Fragment>
      <section>
        <div className={styles.title}>{title}</div>
        {showEmptyDefaultValue && (
          <div className={styles.empty}>{DEFAULT_EMPTY_VALUE}</div>
        )}
        {!showEmptyDefaultValue && (
          <div className={styles.images}>
            {fields.map(field => {
              return (
                <ImageUploader
                  {...field}
                  name={field.fieldName}
                  disabled
                  key={field.fieldName}
                />
              );
            })}
          </div>
        )}
      </section>
    </Fragment>
  );
};

InsuranceCardsSection.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object),
  flowType: PropTypes.string,
  isAdditionalInsurance: PropTypes.bool,
  skipInsurance: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default memo(InsuranceCardsSection);



// WEBPACK FOOTER //
// ./src/components/InsurancesInfo/components/InsuranceCardsSection/index.jsx